import React from "react";
import { HeaderBox, CardTypography } from "./table.styled";

interface Header {
  text: string;
  width: string;
  justifyContent?: string;
  paddingLeft?: string;
  sortable?: boolean;
  sortKey?: string;
}

interface HeaderCardProps {
  headers: Header[];
  containerWidth?: string;
  fontSize?: string;
  onSort?: (sortKey: string) => void;
}

const HeaderCard: React.FC<HeaderCardProps> = ({
  headers,
  containerWidth,
  fontSize,
  onSort,
}) => {
  const handleSort = (sortKey?: string) => {
    if (sortKey && onSort) {
      onSort(sortKey);
    }
  };

  return (
    <HeaderBox width={containerWidth}>
      {headers.map((header, index) => (
        <CardTypography
          key={index}
          width={header.width}
          fontSize={fontSize ? fontSize : "15px"}
          color="black"
          paddingLeft={header.paddingLeft}
          style={{
            wordWrap: "break-word",
            whiteSpace: "normal",
            justifyContent: header.justifyContent ? header.justifyContent : "",
            cursor: header.sortable ? "pointer" : "default",
          }}
          variant="body1"
          onClick={() => handleSort(header.sortKey)}
        >
          {header.text}
        </CardTypography>
      ))}
    </HeaderBox>
  );
};

export default HeaderCard;
